import { render } from "./ProfitLoss.vue?vue&type=template&id=05714875&scoped=true"
import script from "./ProfitLoss.vue?vue&type=script&lang=js"
export * from "./ProfitLoss.vue?vue&type=script&lang=js"

import "./ProfitLoss.vue?vue&type=style&index=0&id=05714875&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05714875"]])

export default __exports__